import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { SearchProjectFields } from '../../../features/feature-search-projects/models/sp-fields.interface'
import { SearchProjectResult } from '../../../features/feature-search-projects/models/sp-result.interface'
import { BasicRequest } from '../../models/interfaces/basic-request.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'

export const openSPSearch = createAction('[search-projects] Open search projects search')

export const closeSPSearch = createAction('[search-projects] Close search projects search')

export const toggleSPSearch = createAction('[search-projects] Toogle search projects search')

export const setIsAdvancedSPSearch = createAction('[search-projects] Set is advanced search', props<{ isAdvanced: boolean }>())

export const setFalseIsAdvancedSPSearch = createAction('[search-projects] Set false is advanced search')

export const toggleAdvancedSPSearch = createAction('[search-projects] Toggle advanced search')

export const search = createAction('[search-projects] Searching', props<{ request: BasicRequest<SearchProjectFields> }>())

export const searchSuccess = createAction(
   '[search-projects] Searching SUCCESS',
   props<{ result: BasicResult<SearchProjectResult[], BasicRequest<SearchProjectFields>> }>()
)

export const searchFailure = createAction('[search-projects] Searching FAILURE', props<{ error: HttpErrorResponse }>())

export const setActualPage = createAction('[search-projects] Setting actual page', props<{ page: number }>())

export const setActualOrder = createAction('[search-projects] Setting actual order', props<{ order: string }>())

export const setItemForPage = createAction('[search-projects] Setting item for page order', props<{ itemForPage: number }>())

export const setSearchRequest = createAction('[search-projects] Setting search request', props<{ request: BasicRequest<SearchProjectFields> }>())

export const initSearch = createAction('[search-projects] Init search')

export const exportExcelResults = createAction('[search-projects] Exporting excel results', props<{ searchFields?: BasicRequest<SearchProjectFields> }>())

export const exportExcelResultsSuccess = createAction('[search-projects] Exporting excel results SUCCESS')

export const exportExcelResultsFailure = createAction('[search-projects] Exporting excel results FAILURE', props<{ error: HttpErrorResponse }>())
